import { $ } from './_utility';

/*------------------------------------------------------------------

  List

-------------------------------------------------------------------*/
function initList() {
  $(
    '.is-style-feature:not(.is-style-styled-ready), .is-style-feature-primary:not(.is-style-styled-ready)'
  ).each(function () {
    const $this = $(this);
    const start = parseInt($this.attr('start'), 10);
    const isReversed = 'undefined' !== typeof $this.attr('reversed');
    const itemsCount = $this.children().length;

    $this.addClass('is-style-styled-ready');

    if (isReversed) {
      $this.css('counter-reset', `li ${(start || itemsCount) + 1}`);
    } else if (start) {
      $this.css('counter-reset', `li ${start - 1}`);
    }
  });
}

export { initList };
